import { Tolgee, FormatSimple } from '@tolgee/react';
import { getStorage } from 'helpers/sessionContext';
import { BackendFetch } from '@tolgee/web';
// @ts-ignore - Importante: Se usa el entry point /tools para garantizar que el editor no sea eliminado en builds de producción
import { InContextTools } from '@tolgee/web/tools';
import { logger } from './helpers/logger';
import esLocale from './locales/translations/es-MX.json';
import enLocale from './locales/translations/en.json';

const isBrowser = typeof window !== 'undefined';
const cdnUrl = 'https://cdn.tolg.ee/9518fae64685d0d31bd0e4d351047bd8/';

/**
 * Detecta si el modo Staff está activo (vía URL o LocalStorage)
 */
const getStaffMode = () => {
    if (!isBrowser) return false;
    const params = new URLSearchParams(window.location.search);

    // Desactivación explícita
    if (params.get('edit_mode') === 'false') {
        getStorage().removeItem('tg_staff_mode');
        getStorage().removeItem('tg_api_key');
        return false;
    }

    // Activación explícita
    if (params.get('edit_mode') === 'true') {
        getStorage().setItem('tg_staff_mode', 'true');
        return true;
    }

    return getStorage().getItem('tg_staff_mode') === 'true';
};

const isStaffMode = getStaffMode();
const savedKey = isBrowser ? getStorage().getItem('tg_api_key') : null;

// 1. Configuramos el Builder básico
let tolgeeBuilder = Tolgee().use(FormatSimple());

// 2. Inyección de plugins según el entorno
if (isStaffMode) {
    // Modo Edición: Forzamos la inclusión de las InContextTools
    tolgeeBuilder = tolgeeBuilder.use(InContextTools());
} else {
    // Modo Usuario: Consumo optimizado vía CDN
    tolgeeBuilder = tolgeeBuilder.use(BackendFetch({
        prefix: cdnUrl,
        getPath: ({ prefix, language }) => {
            // Normalización para Cincel: Español siempre a es-MX
            const lang = language.toLowerCase().startsWith('es') ? 'es-MX' : language;
            return `${prefix}translations/${lang}.json`;
        },
        fallbackOnFail: true
    }));
}

// 3. Inicialización de la Instancia
export const tolgee = tolgeeBuilder.init({
    language: 'es-MX',
    apiUrl: 'https://app.tolgee.io',
    projectId: 28169,
    apiKey: savedKey || undefined,
    staticData: {
        'es-MX:translations': esLocale,
        'es:translations': esLocale,
        'en:translations': enLocale,
    },
});

// 4. Exposición y Logs de Éxito
if (isBrowser) {
    (window as any).tolgee = tolgee;

    if (isStaffMode) {
        logger.log('👷 Tolgee: MODO EDITOR ACTIVADO');
        // Pequeña verificación silenciosa
        setTimeout(() => {
            if (!(window as any).__TOLGEE_DEV_TOOLS__) {
                logger.warn('⚠️ Tolgee: Editor cargado, pero esperando API Key válida.');
            }
        }, 1000);
    }
}
